import React from 'react';
import { useRecordContext } from 'react-admin';
import Chip from '@mui/material/Chip';

const statusConfig = {
    draft: { label: 'Draft', color: 'default' },
    todo: { label: 'Todo', color: 'info' },
    in_progress: { label: 'In Progress', color: 'primary' },
    paused: { label: 'Paused', color: 'warning' },
    done: { label: 'Done', color: 'success' },
    canceled: { label: 'Canceled', color: 'error' }
};

const StatusField = () => {
    const record = useRecordContext();
    if (!record || !record.status) return null;

    const config = statusConfig[record.status] || { label: record.status, color: 'default' };

    return <Chip label={config.label} color={config.color} size="small" />;
};

export default StatusField;
